<template>
    <div class="review-set-modal">
        <base-modal :mk="`${mode}-review-set`" :show.sync="openModal" :styles="modalStyles">
            <section class="review-set-modal-header">
                <p class="title">{{ currentStep.title }}</p>
            </section>
            <component
                :is="currentStep.component"
                :set="currentStep.set"
                :mode="mode"
                :btn-fns="{
                    acceptConfirmation,
                    rejectConfirmation,
                    declineConfirmation,
                    messageVenue,
                    closeModal: () => (openModal = false)
                }"
            ></component>
        </base-modal>
    </div>
</template>
<script>
    import BaseModal from '@/components/ui/modals/BaseModal.vue'
    import { useReviewSet } from '@/composables/features/artist-booking/review-set/useReviewSet'

    export default {
        name: 'ReviewSetModal',
        components: {
            BaseModal
        },
        props: {
            eventId: {
                required: true,
                type: Number
            },
            show: {
                required: true,
                type: Boolean
            },
            mode: {
                required: true,
                type: String
            },
            set: {
                required: false,
                type: Object,
                default: null
            }
        },
        emits: ['update:show', 'loading', 'changes-accepted'],
        setup(props, context) {
            const {
                modalStyles,
                openModal,
                currentStep,
                acceptConfirmation,
                rejectConfirmation,
                declineConfirmation,
                messageVenue
            } = useReviewSet(props, context)

            return {
                modalStyles,
                openModal,
                currentStep,
                acceptConfirmation,
                rejectConfirmation,
                declineConfirmation,
                messageVenue
            }
        },
        methods: {
            getAsset(path, dir = 'images') {
                return `/${dir}/${path}`
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    button:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
    button:hover {
        background: #dedede;
    }

    .review-set-modal-header {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-bottom: -3px;

        .title {
            margin-right: auto;
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 20px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
            letter-spacing: -0.2px;
        }
        .cancel-btn {
            position: absolute;
            top: -7px;
            right: -64px;
            display: flex;
            background: none;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 8px;
            padding: 10px 16px;
            color: #cdeb09;
            font-family: 'Instrument Sans';
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 125%;

            .cancel-btn-icon {
                width: 20px;
                height: 20px;
            }
        }
        .cancel-btn:hover {
            background: none;
        }
    }
    .cta-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 12px 32px;
        background: #cdeb09;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 133%;
        border-radius: 120px;
    }
    @media screen and (max-width: 600px) {
        .cancel-btn {
            right: 0 !important;
        }
    }
</style>
